import React from "react";
import { useNavigate } from "react-router-dom";
import SiteNav from "@/components/SiteNav";
import Report from "@/components/Report";

const mk = (name, probes, score) => ({ code: name.slice(0, 3).toUpperCase(), name, probes, score, max: 3, significance: score >= 3 ? "High" : score >= 2 ? "Moderate" : score >= 1 ? "Low" : "Very Low" });

const SAMPLE = {
  testId: "MSI-SAMPLE",
  testType: "MSOS",
  institution: "Sample Institute of Management",
  candidateEmail: "s*****t@example.com",
  completedAt: new Date().toISOString(),
  overall: { score: 68, max: 90, percentage: 75.6 },
  recommended: { code: "ADB", name: "Analytics and Digital Business", percentage: 86.7 },
  domains: [
    {
      code: "ADB", name: "Analytics and Digital Business", score: 26, max: 30, percentage: 86.7,
      constructs: [
        mk("Data-Driven", "Uses evidence rather than opinion to decide.", 3),
        mk("Logical Analysis", "Breaks a problem into structured parts.", 3),
        mk("Tech Adoption", "Judges when a tool genuinely helps.", 2),
        mk("Pattern Finding", "Spots trends within noisy information.", 3),
        mk("Modelling", "Represents a situation with a simple model.", 2),
        mk("Automation Sense", "Recognises repeatable, automatable work.", 3),
        mk("Metric Design", "Chooses the measure that matters.", 3),
        mk("Signal vs Noise", "Separates meaningful change from randomness.", 2),
        mk("Experimentation", "Tests before committing at scale.", 3),
        mk("Insight to Action", "Turns a finding into a decision.", 2),
      ],
    },
    {
      code: "SC", name: "Strategy and Consulting", score: 23, max: 30, percentage: 76.7,
      constructs: [
        mk("Structured Problem", "Frames an ambiguous problem cleanly.", 3),
        mk("Competitive Analysis", "Reads the moves of rivals.", 2),
        mk("Advisory Thinking", "Balances options for a decision-maker.", 3),
        mk("Executive Comms", "Leads with the answer, then support.", 2),
        mk("Long-term Judgement", "Weighs durable over quick wins.", 2),
        mk("Big-picture Reasoning", "Connects parts to the whole.", 3),
        mk("Hypothesis-led", "Starts from a testable claim.", 2),
        mk("Prioritisation", "Focuses effort on what moves the needle.", 3),
        mk("Trade-off Clarity", "Names what is given up for a gain.", 1),
        mk("Synthesis", "Combines findings into a recommendation.", 2),
      ],
    },
    {
      code: "FIN", name: "Finance", score: 19, max: 30, percentage: 63.3,
      constructs: [
        mk("Value", "Judges worth relative to sacrifice.", 2),
        mk("Risk", "Reasons about adverse outcomes.", 2),
        mk("Reward", "Compares upside for comparable effort.", 2),
        mk("Time Horizon", "Accounts for timing of outcomes.", 1),
        mk("Resource Allocation", "Distributes limited resources well.", 2),
        mk("Cost–Benefit", "Checks if extra benefit justifies cost.", 2),
        mk("Liquidity Sense", "Values access to cash when needed.", 2),
        mk("Break-even", "Finds the point of no loss.", 2),
        mk("Sensitivity", "Sees how outcomes shift with inputs.", 2),
        mk("Discipline", "Sticks to a sound financial rule.", 2),
      ],
    },
  ],
};

export default function SampleReport() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50">
      <SiteNav />
      <div className="max-w-6xl mx-auto px-5 pt-8">
        <div className="rounded-lg bg-blue-50 border border-blue-200 text-blue-800 px-5 py-3 text-sm">
          This is a <b>sample</b> MSOS report with illustrative scores, to show what candidates receive. Buy a test to generate your own.
        </div>
      </div>
      <Report report={SAMPLE} onRestart={() => navigate("/")} />
    </div>
  );
}
